module.exports = __webpack_public_path__ + "img/giftbox.f35a45c.jpg";